<i18n>
{
  "ru": {
    "city": "г. Днепр",
    "address": "Главный офис – 49027, Украина, г. Днепр, ул. Владимира Вернадского 37.",
    "address2": "Завод – Украина, г. Днепр, пр-кт Богдана Хмельницкого 122-А.",
    "phones": "Секретарь",
    "sales": "Отдел продаж"
  },
  "uk": {
    "city": "місто Дніпро",
    "address": "Головний офіс - 49027, Україна, м. Дніпро, вул. Володимира Вернадського 37.",
    "address2": "Завод - Україна, проспект Богдана Хмельницького 122-А.",
    "phones": "Секретар",
    "sales": "Відділ продажу"
  },
  "eng": {
    "city": "Dnipro city",
    "address": "Main Office – 49027, Ukraine, Dnipro city, Volodymyra Vernadskoho Street 37.",
    "address2": "Factory - Ukraine, Dnipro city, Bohdana Khmelnytskoho Avenue 122-A.",
    "phones": "Secretary",
    "sales": "Sales Office"
  },
  "pl": {
    "city": "miasto Dniepr",
    "address": "Główne biuro– 49027, Ukraina, miasto Dniepr, ulica Władimira Wiernadskiego 37.",
    "address2": "Zakład – Ukraina, miasto Dniepr, prospekt Bogdana Chmielnickiego 122-A.",
    "phones": "Sekretarz",
    "sales": "Dział sprzedaży"
  },
  "de": {
    "city": "Stadt Dnipro",
    "address": "Hauptsitz – 49027, Ukraine, Stadt Dnipro, Wolodymyra-Wernadskoho-Straße 37.",
    "address2": "Betrieb – Ukraine, Stadt Dnipro, Bohdana-Chmelnyzkoho-Prospekt 122-A.",
    "phones": "Sekretär",
    "sales": "Vertriebsabteilung"
  }
}
</i18n>

<template>
  <div class="contacts-page">
    <div class="container">
      <div class="title_holder">
        <h3>{{ $t("nav.contact") }}</h3>
        <div class="breadcrumbs">
          <ul>
            <li class="item-home">
              <router-link class="bread-link bread-home" to="/" title="Home">{{
                $t("nav.main")
              }}</router-link>
            </li>
            <li class="separator separator-home">
              <span></span>
            </li>
            <li class="item-current">
              <span class="bread-current">{{ $t("nav.contact") }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="feedback">
        <div class="row">
          <div class="col-md-12">
            <ul class="list">
              <li>
                <div class="item">
                  <div class="title">
                    <span class="icon_wrapper">
                      <span class="icon">
                        <img
                          width="30"
                          height="30"
                          src="../assets/images/location.svg"
                        />
                      </span>
                      <span class="shape"></span>
                    </span>
                    <h3>{{ $t("city") }}</h3>
                  </div>
                  <div class="content_holder">
                    <p>
                      <span>{{ $t("address") }}</span>
                      <span>{{ $t("address2") }}</span>
                      <span>
                        {{ $t("phones") }}:
                        <span>+38 (056) 370-43-12</span>
                        <span>
                          Email:
                          <a href="mailto:stroikomp@ukr.net"
                            >stroikomp@ukr.net</a
                          >
                        </span>
                      </span>
                      <span>
                        {{ $t("sales") }}
                        <span>+38 (098) 541-60-05</span>
                        <span>
                          Email:
                          <a href="mailto:sk@stroikomp.com.ua"
                            >sk@stroikomp.com.ua</a
                          >
                        </span>
                        <span>
                          <a
                            href="https://www.facebook.com/stroikomp.com.ua"
                            style="width:30px;display:block;"
                            ><img src="../assets/images/fb.png"
                          /></a>
                        </span>
                      </span>
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="col-md-12">
            <div class="as-map">
              <GmapMap ref="gMap" :center="mapOptions.center" :zoom="11">
                <GmapMarker
                  :key="index"
                  v-for="(m, index) in mapOptions.markers"
                  :position="m.position"
                  @click="toggleInfoWindow(m, index)"
                ></GmapMarker>

                <gmap-info-window
                  :options="mapOptions.infoOptions"
                  :position="mapOptions.infoWindowPos"
                  :opened="mapOptions.infoWinOpen"
                  @closeclick="mapOptions.infoWinOpen = false"
                >
                  <div v-html="mapOptions.infoContent"></div>
                </gmap-info-window>
              </GmapMap>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        email: "",
        name: "",
        type: "",
        desc: ""
      },
      show: true,
      mapOptions: {
        infoContent: "",
        infoWindowPos: {
          lat: 0,
          lng: 0
        },
        map: null,
        infoWinOpen: false,
        currentMidx: null,
        center: {
          lat: 48.4624412,
          lng: 34.8602728
        },
        markers: [
          {
            name: "Главный офис",
            description: "Украина, г. Днепр, ул. Владимира Вернадского 37",
            position: {
              lat: 48.4624474,
              lng: 35.0649486
            },
          },
          {
            name: "Завод",
            description: "Украина, г. Днепр, пр-кт Богдана Хмельницкого 122-А",
            position: {
              lat: 48.4055835,
              lng: 34.9976943
            }
          }
        ]
      }
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      alert(JSON.stringify(this.form));
    },
    onReset(evt) {
      evt.preventDefault();
      /* Reset our form values */
      this.form.email = "";
      this.form.name = "";
      this.form.food = null;
      this.form.checked = [];
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    toggleInfoWindow: function(marker, idx) {
      this.mapOptions.infoWindowPos = marker.position;
      this.mapOptions.infoContent = this.getInfoWindowContent(marker);

      //check if its the same marker that was selected if yes toggle
      if (this.mapOptions.currentMidx == idx) {
        this.mapOptions.infoWinOpen = !this.mapOptions.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.mapOptions.infoWinOpen = true;
        this.mapOptions.currentMidx = idx;
      }
    },

    getInfoWindowContent: function(marker) {
      return `<div class="card">
        <div class="card-content">
          <div class="media">
            <div class="media-content">
              <p class="title is-4">${marker.name}</p>
              <p>${marker.description}</p>
            </div>
          </div>
        </div>
      </div>`;
    }
  },
  mounted() {
    this.$refs.gMap.$mapPromise.then(map => {
      const bounds = new google.maps.LatLngBounds();
      for (let m of this.mapOptions.markers) {
        bounds.extend(m.position);
      }
      map.fitBounds(bounds);
    });
  },
};
</script>

<style>
.as-map {
  margin-bottom: 30px;
  border-radius: 3px;
  overflow: hidden;
}
.as-map > div {
  width: 100%;
  height: 500px;
}
.card {
  border: none;
}
.card .title {
  font-weight: bold;
  font-size: 16px;
}
.card p:last-child {
  margin: 0;
}
.feedback {
  padding-top: 30px;
  padding-bottom: 30px;
}
.feedback .list .title {
  width: 100%;
  float: left;
  clear: both;
  padding: 21px 80px 21px 40px;
  position: relative;
  box-sizing: border-box;
  background-color: #111422;
  color: #fff;
}
.feedback .icon_wrapper {
  width: 80px;
  bottom: 0px;
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 5;
  overflow: hidden;
}
.feedback .list {
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.feedback .list .item {
  border-radius: 5px;
  overflow: hidden;
  width: 100%;
  float: left;
  clear: both;
  position: relative;
  margin-bottom: 30px;
}
.feedback .list .item h3 {
  margin: 0px;
  padding: 0px;
  font-size: 22px;
  font-weight: 400;
  letter-spacing: 0px;
  color: #eee;
}
.feedback .icon_wrapper .icon {
  background-color: #d24e1a;
  width: 60px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  position: absolute;
  display: block;
  color: #fff;
}
.feedback .icon_wrapper .shape {
  background-color: #d24e1a;
  width: 30px;
  position: absolute;
  content: "";
  left: 20px;
  top: -20px;
  bottom: 0px;
  transform-origin: bottom;
  z-index: -1;
  transition: all 0.3s ease;
}
.feedback .item:hover .shape {
  transform: rotate(-13deg);
}
.feedback .icon_wrapper .icon img {
  position: absolute;
  width: 30px;
  height: 30px;
  top: 50%;
  left: 50%;
  margin: -15px 0px 0px -15px;
}
.feedback .content_holder {
  width: 100%;
  float: left;
  clear: both;
  padding: 34px 40px;
  box-sizing: border-box;
  background-color: #0d0e13;
}
.feedback .content_holder p {
  color: #999;
  margin: 0px;
  padding: 0px;
  line-height: 1.5;
}
.feedback .content_holder p span {
  display: block;
  margin-bottom: 8px;
}
.feedback-block {
  border-radius: 3px 3px 3px 3px;
  background-color: #e9eff4;
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
  padding: 20px 20px 20px 20px;
}
.feedback-block .title {
  margin-bottom: 20px;
}
.contacts-page .title_holder {
  position: relative;
  padding: 95px 0 35px;
  width: 100%;
  float: left;
  clear: both;
}
.form-feedback [type="submit"] {
  border: none;
  height: 44px;
  font-weight: 500;
  font-size: 14px;
  padding: 0 25px !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background-color: #d24e1a;
  color: #fff;
}
.contacts-page .title_holder:before {
  bottom: 13px;
  width: 150px;
  border-radius: 10px;
}
.contacts-page .title_holder:after {
  bottom: 0;
  width: 70px;
  border-radius: 10px;
}
.contacts-page .title_holder:before,
.contacts-page .title_holder:after {
  left: 0;
  position: absolute;
  height: 6px;
  background-color: #eee;
  content: "";
}
.contacts-page .title_holder .breadcrumbs {
  width: 100%;
  float: left;
  clear: both;
  position: relative;
  padding-top: 13px;
  padding-bottom: 2px;
}
.contacts-page .title_holder .breadcrumbs ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.contacts-page .title_holder .breadcrumbs li {
  float: left;
  margin-bottom: 5px;
}
.contacts-page .title_holder .breadcrumbs li a {
  font-size: 14px;
  color: #666;
  text-decoration: none;
  letter-spacing: 0;
  line-height: 1.5;
  font-weight: 600;
}
.contacts-page .title_holder .breadcrumbs .separator span {
  width: 33px;
  height: 24px;
  display: block;
  position: relative;
}
.contacts-page .title_holder .breadcrumbs .separator span:after,
.contacts-page .title_holder .breadcrumbs .separator span:before {
  width: 9px;
  height: 2px;
  display: block;
  position: absolute;
  background-color: #ddd;
  left: 13px;
  content: "";
}
.contacts-page .title_holder .breadcrumbs .separator span:before {
  top: 14px;
  transform: rotate(135deg);
}
.contacts-page .title_holder .breadcrumbs .separator span:after {
  top: 8px;
  transform: rotate(45deg);
}
</style>
